import React, { Suspense, lazy } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { TOOL_SLUGS } from '../data/toolSlugs';

const Home = lazy(() => import('../components/Home/Home'));
const ToolPage = lazy(() => import('../components/Tools/ToolPage'));
const About = lazy(() => import('../components/Pages/About'));
const Contact = lazy(() => import('../components/Pages/Contact'));
const Privacy = lazy(() => import('../components/Pages/Privacy'));
const Terms = lazy(() => import('../components/Pages/Terms'));
const Blog = lazy(() => import('../components/Pages/Blog'));
const BlogDetail = lazy(() => import('../components/Pages/BlogDetail'));
const Login = lazy(() => import('../components/Admin/Login/Login'));
const AdminLayout = lazy(() => import('../components/Admin/Layout/AdminLayout'));
const BlogManager = lazy(() => import('../components/Admin/Blog/BlogManager'));
const ProtectedRoute = lazy(() => import('../components/Admin/ProtectedRoute'));

const routeFallback = (
  <div className="flex items-center justify-center min-h-[40vh] text-gray-500 dark:text-gray-400">
    Loading…
  </div>
);

const AppRoutes = () => {
  return (
    <Suspense fallback={routeFallback}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:id" element={<BlogDetail />} />
        <Route path="/admin/login" element={<Login />} />
        <Route
          path="/admin/blog"
          element={
            <ProtectedRoute>
              <AdminLayout>
                <BlogManager />
              </AdminLayout>
            </ProtectedRoute>
          }
        />

        {TOOL_SLUGS.map((t) => (
          <Route key={t.seoPath} path={t.seoPath} element={<ToolPage />} />
        ))}

        <Route
          path="/postman-to-swift-api-generator"
          element={<Navigate replace to="/postman-to-swift-api-client" />}
        />

        {TOOL_SLUGS.filter((t) => t.legacyPath).map((t) => (
          <Route
            key={t.legacyPath}
            path={t.legacyPath}
            element={<Navigate replace to={t.seoPath} />}
          />
        ))}
      </Routes>
    </Suspense>
  );
};

export default AppRoutes;
